// extracted by mini-css-extract-plugin
export default {"input":"otp_input__inr48","input_container":"otp_input_container__TOqyn","error_input":"otp_error_input__KDcpw"};